import { http, cacheFirstConfig } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { PartnerProfession } from './partner-profession.interface';

export class PartnerProfessionService {
   async getPartnerProfessions() {
      return await http
         .get<ApiResource<Array<PartnerProfession>>>(`/partner_professions`, cacheFirstConfig)
         .then((response) => response.data);
   }
}
